import { ProductVariantId, VariantSlug } from './product'

export interface Cart {
  readonly subtotalPrice: string
  readonly items: CartItem[]
  readonly isValid: boolean
}

export interface CartItem {
  readonly id: string | null
  readonly title: string
  readonly quantity: number
  readonly price: string
  readonly variantId: ProductVariantId
  readonly variantSlug: VariantSlug
}

export const emptyCart: Cart = {
  subtotalPrice: '0.00',
  items: [],
  isValid: false,
}
